import styled from "styled-components";

export const StyledMain = styled.main`
	padding-top: 20px;
	padding-bottom: 20px;
	width: 100%;
	display: flex;
	justify-content: center;
	min-height: 300px;
`;

export const StyledContainer = styled.div`
	width: 100%;
	max-width: 800px;
	
	border-radius: 5px;

	.slider {
		img {
			object-fit: cover !important;
			width: 100% !important;
			height: 100% !important;
		}
	}

	&:hover {
	}
	@media (max-width: 600px) {
		padding: 10px 5px;
	}
`;





